var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.854,
    height: 18.947,
    viewBox: "0 0 18.854 18.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30769",
    "data-name": "Group 30769",
    transform: "translate(14279 13311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67876",
    "data-name": "Path 67876",
    d: "M8.78,16.443H2.49A1.748,1.748,0,0,1,.75,14.695V2.49A1.742,1.742,0,0,1,2.49.75h12.2a1.748,1.748,0,0,1,1.748,1.74V8.912",
    transform: "translate(-14279 -13311)",
    fill: "none",
    stroke: "#4b74be",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9121",
    "data-name": "Rectangle 9121",
    width: 10.775,
    height: 1.046,
    transform: "translate(-14275.792 -13307.157)",
    fill: "#4b74be"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9122",
    "data-name": "Rectangle 9122",
    width: 10.775,
    height: 1.046,
    transform: "translate(-14275.792 -13304.107)",
    fill: "#4b74be"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9123",
    "data-name": "Rectangle 9123",
    width: 4.31,
    height: 1.046,
    transform: "translate(-14275.792 -13301.058)",
    fill: "#4b74be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67877",
    "data-name": "Path 67877",
    d: "M17.049,13.927a3.244,3.244,0,1,1-3.244,3.244,3.248,3.248,0,0,1,3.244-3.244m0-1.171a4.414,4.414,0,1,0,4.414,4.414,4.415,4.415,0,0,0-4.414-4.414",
    transform: "translate(-14281.61 -13313.637)",
    fill: "#4b74be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67878",
    "data-name": "Path 67878",
    d: "M19.656,16.74l-2.611,2.611-1.187-1.187",
    transform: "translate(-14282.318 -13314.512)",
    fill: "none",
    stroke: "#4b74be",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationActive);
export default __webpack_public_path__ + "static/media/VerificationActive.6afb19f1c84ff3203c9235a918ea67eb.svg";
export { ForwardRef as ReactComponent };